<template>
    <div>
        <Header />
        <PageTitle />
        <CartContent />
        <Footer />
    </div>
</template>

<script>
import Header from '../Layout/Header'
import PageTitle from '../Cart/PageTitle'
import CartContent from '../Cart/CartContent'
import Footer from '../Layout/Footer'

export default {
    name: 'CartPage',
    components: {
        Header,
        PageTitle,
        CartContent,
        Footer,
    }
}
</script>